import React, {useState} from 'react';
import useOutsideClick from "../../../../hooks/useOutsideClick";
import SelectItem from "../SelectItem";
import {initialStatusData} from "../TdStatus";
import StatusNameColorFactory from "../../../../constants/StatusNameColorFactory";
import styles from './styles.module.scss';
import ModalApproveChangeStatus from "./ModalApproveChangeStatus";

const IconMenu = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M12 13.125C12.6213 13.125 13.125 12.6213 13.125 12C13.125 11.3787 12.6213 10.875 12 10.875C11.3787 10.875 10.875 11.3787 10.875 12C10.875 12.6213 11.3787 13.125 12 13.125Z"
            fill="#1E1E1E"/>
        <path
            d="M12 7.125C12.6213 7.125 13.125 6.62132 13.125 6C13.125 5.37868 12.6213 4.875 12 4.875C11.3787 4.875 10.875 5.37868 10.875 6C10.875 6.62132 11.3787 7.125 12 7.125Z"
            fill="#1E1E1E"/>
        <path
            d="M12 19.125C12.6213 19.125 13.125 18.6213 13.125 18C13.125 17.3787 12.6213 16.875 12 16.875C11.3787 16.875 10.875 17.3787 10.875 18C10.875 18.6213 11.3787 19.125 12 19.125Z"
            fill="#1E1E1E"/>
    </svg>
);

const IconItem = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M15.3874 6.79299C15.2502 6.75609 15.0928 6.75007 14.5014 6.75007H7.2002C6.62777 6.75007 6.24344 6.75065 5.94745 6.77483C5.66016 6.79829 5.52281 6.84019 5.43229 6.88631C5.19709 7.00615 5.00608 7.19716 4.88624 7.43236C4.84012 7.52288 4.79822 7.66023 4.77476 7.94751C4.75058 8.24351 4.75 8.62784 4.75 9.20026V14.8003C4.75 15.3727 4.75058 15.7568 4.77476 16.0526C4.79821 16.3396 4.84008 16.4769 4.88624 16.5675C5.0063 16.8031 5.19751 16.9944 5.43229 17.114C5.52263 17.1601 5.65973 17.2019 5.9465 17.2253C6.24198 17.2495 6.62558 17.2501 7.19691 17.2501H14.5014C15.0924 17.2501 15.2501 17.2439 15.3874 17.207C15.5289 17.1689 15.6627 17.1063 15.7822 17.0221C15.8988 16.9401 16.0065 16.8215 16.3838 16.3688L18.7171 13.5688C19.0278 13.196 19.234 12.9475 19.38 12.7427C19.5205 12.5457 19.573 12.4321 19.5984 12.3431C19.6624 12.119 19.6624 11.8809 19.5984 11.6567C19.5731 11.5678 19.5206 11.4545 19.3801 11.2575C19.2341 11.0528 19.0279 10.8045 18.7171 10.4316L16.3838 7.63157C16.006 7.17819 15.8986 7.05958 15.7822 6.97767C15.6629 6.89373 15.5292 6.83116 15.3874 6.79299ZM14.5833 5.25003C15.0542 5.24973 15.4239 5.24949 15.7771 5.3445C16.0875 5.42803 16.3817 5.56534 16.6455 5.75099C16.9461 5.96251 17.1843 6.24873 17.4888 6.6145C17.5044 6.63322 17.5202 6.65216 17.5361 6.6713L19.8847 9.48953C20.1745 9.83738 20.4181 10.1297 20.6013 10.3864C20.7931 10.6553 20.9502 10.9273 21.0409 11.2452C21.1815 11.7383 21.1815 12.2615 21.0409 12.7546C20.9502 13.0724 20.7932 13.3445 20.6014 13.6135C20.4177 13.8712 20.1732 14.1646 19.882 14.5139L17.5361 17.329C17.5212 17.347 17.5064 17.3647 17.4918 17.3822C17.1854 17.7502 16.9469 18.0367 16.6455 18.2488C16.382 18.4343 16.0878 18.5719 15.7771 18.6555C15.4234 18.7506 15.0534 18.7504 14.581 18.7501C14.5548 18.7501 14.5283 18.7501 14.5014 18.7501H7.16649C6.63341 18.7501 6.18817 18.7501 5.82433 18.7204C5.44487 18.6893 5.08837 18.6223 4.7513 18.4506C4.23343 18.1867 3.81317 17.7655 3.54973 17.2484C3.37791 16.9112 3.31078 16.5547 3.27974 16.1748C3.24998 15.8106 3.24999 15.3649 3.25 14.8307V9.16985C3.24999 8.63568 3.24998 8.18973 3.27974 7.8254C3.31077 7.44548 3.37787 7.08868 3.54973 6.75137C3.81338 6.23393 4.23386 5.81345 4.7513 5.5498C5.08861 5.37793 5.44541 5.31084 5.82534 5.27981C6.18966 5.25005 6.63561 5.25006 7.16978 5.25007L14.5014 5.25007C14.5291 5.25007 14.5564 5.25005 14.5833 5.25003Z"
              fill="#1E1E1E"/>
    </svg>
)

const LeftArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M8.46967 18.5303C8.17678 18.2374 8.17678 17.7626 8.46967 17.4697L13.9393 12L8.46967 6.53033C8.17678 6.23744 8.17678 5.76256 8.46967 5.46967C8.76256 5.17678 9.23744 5.17678 9.53033 5.46967L15.5303 11.4697C15.8232 11.7626 15.8232 12.2374 15.5303 12.5303L9.53033 18.5303C9.23744 18.8232 8.76256 18.8232 8.46967 18.5303Z"
              fill="#1E1E1E"/>
    </svg>
);

interface IProps {
    handlePatchStatusBatch: (status: string) => void;
    amount: number
}

const CheckedMenu = ({handlePatchStatusBatch, amount}:IProps) => {
    const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);
    const [isOpenStatuses, setIsOpenStatuses] = useState<boolean>(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState<string>('');

    const handleToggleMenu = () => setIsOpenMenu((prev) => !prev);
    const handleCloseMenu = () => setIsOpenMenu(false);
    const handleToggleStatuses = () => setIsOpenStatuses((prev) => !prev);
    const handleCloseStatuses = () => setIsOpenStatuses(false);

    const handleOpenModal = () => setIsOpenModal(true);
    const handleCloseModal = () => setIsOpenModal(false);


    const ref = useOutsideClick(() => {
        handleCloseMenu();
        handleCloseStatuses();
    });

    const handleChangeStatus = () => {
        handlePatchStatusBatch(selectedStatus);
        handleCloseMenu();
        handleCloseStatuses();
        handleCloseModal()
    }

    const handleSelectStatus = (e:React.MouseEvent<HTMLButtonElement>) => {
        const status = e.currentTarget.id;
        setSelectedStatus(status);
        handleOpenModal();
    }

    return (
        <>
            {isOpenModal ? (
                <ModalApproveChangeStatus
                    handleClose={handleCloseModal}
                    selectedStatus={selectedStatus}
                    handleApply={handleChangeStatus}
                />
            ) : null}
            <div
                ref={ref}
                className={styles.menu}
            >
                {amount !== 0 ? (
                    <button
                        className={styles.menu__btn}
                        type={'button'}
                        onClick={handleToggleMenu}
                    >
                        Selected
                        <div className={styles.menu__amount}>
                            {amount}
                        </div>
                        <IconMenu/>
                    </button>
                ) : null}
                {isOpenMenu ? (
                    <div className={styles.menu__list}>
                        <button
                            className={styles.menu__item}
                            type={'button'}
                            onClick={handleToggleStatuses}
                        >
                            <div className={styles.menu__item_name}>
                                <IconItem/>
                                <span>
                            Змінити статус на
                        </span>
                            </div>
                            <LeftArrowIcon/>
                        </button>
                    </div>
                ) : null}
                {isOpenStatuses ? (
                    <div className={styles.menu__statuses}>
                        {initialStatusData.map((item) => (
                            <SelectItem
                                handleSelect={handleSelectStatus}
                                label={item.label}
                                value={item.value}
                                color={StatusNameColorFactory(item.value).color}
                            />
                        ))}
                    </div>
                ) : null}
            </div>
        </>
    );
};

export default CheckedMenu;
